import React from 'react';
import { FaSave, FaUpload } from 'react-icons/fa';
import '../styles/Partners.css';

const CreatePartner = () => (
  <div className="partners-page">
    <h1>Create Partner</h1>
    <p>Add a new business partner.</p>
    <div className="partner-form">
      <div className="form-group"><label>Company Name</label><input type="text" placeholder="Company name" /></div>
      <div className="form-group"><label>Contact Person</label><input type="text" placeholder="Contact person" /></div>
      <div className="form-row">
        <div className="form-group"><label>Email</label><input type="email" placeholder="Email" /></div>
        <div className="form-group"><label>Phone</label><input type="tel" placeholder="Phone" /></div>
      </div>
      <div className="form-group"><label>Partnership Area</label><select><option>Select area</option><option>Power Distribution</option><option>Solar Energy</option><option>Construction</option><option>Security</option></select></div>
      <div className="form-group"><label>Logo</label><input type="file" /></div>
      <button className="submit-btn"><FaSave /> Create Partner</button>
    </div>
  </div>
);
export default CreatePartner;
